/***************************************************************
5/22/2017
Alexander Self
Timesheet View
- Displays a list of employees
***************************************************************/
import React from 'react';

const EmployeeList = ({ employees, onclick, icon, _class, header, isEditOrDelete, onClick }) => {
  /* Check if this is the edit or delete module */
  if (isEditOrDelete) {
    return (
      <ul className="collection with-header">
        <li className="collection-header">{header}</li>
        {
          employees.map((e) => {
            return (
              <li className="collection-item" key={e.id}>
                <span className="emp-name">{ e.firstName } { e.lastName }</span> <br />
                <button className={`btn-floating waves-effect waves-light ${_class}`} onClick={() => onClick(e)}>
                  <i className="material-icons">{icon}</i>
                </button>
              </li>
            )
          })
        }
      </ul>
    );
  }
  return (
    <ul className="collection with-header">
      <li className="collection-header">{header}</li>
      {
        employees.map((e) => {
          if (e.status) {
            return (
              <li className="collection-item" key={e.id}>
                <span className="emp-name">{ e.firstName } { e.lastName }</span> <br />
                <button className={`btn-floating waves-effect waves-light ${_class} grey`} onClick={() => onClick(e)}>
                  <i className="material-icons">{icon}</i>
                </button>
              </li>
            );
          }
          return (
            <li className="collection-item" key={e.id}>
              <span className="emp-name">{ e.firstName } { e.lastName }</span> <br />
              <button className={`btn-floating waves-effect waves-light ${_class}`} onClick={() => onClick(e)}>
                <i className="material-icons">{icon}</i>
              </button>
            </li>
          )
        })
      }
    </ul>
  );
};

export default EmployeeList;













/* END */



// WEBPACK FOOTER //
// ./src/components/employee_list.js